import {
  reactive,
  toRefs,
  ref,
  computed,
  nextTick,
} from '@vue/composition-api';
import {
  ERROR_CODE_VERIFY_RECAPTCHA,
  ERROR_CODE_VERIFY_RECAPTCHA_STRING,
  ERROR_PHONE_INCORRECT,
  ERROR_CODE_TOO_MANY_TRIES_VERIFY_PHONE,
} from '@/js/utils/constants/constErrorsCode';
import { ERROR_CHECK_USER_PROBLEM } from '@/js/utils/constants/constUser';
import { getDifferenceBetweenDateTypes } from '@/js/utils/dateTime';
import { userSendConfirmCode, userSendReceivedCode } from '@/js/repositories/User';
import sendReceivedCodeNew from '@/js/services/api/sendReceivedCodeNew';
import getPhoneInfo from '@/js/services/api/getPhoneInfo';
import sendSmsConfirmNew from '@/js/services/api/sendSmsConfirmNew';

const useSmsConfirm = (props, { emit }) => {
  const countdown = ref(null);

  const params = reactive({
    showForm: true,
    value: '',
    timeLeft: 0,
    errorSendReceivedCode: '',
    hideResendBtn: false,
    isCounting: false,
    isSendingCode: false,
    isFetchingCode: false,
    localCaptchaOptions: {},
    state: '',
    showCaptchaError: false,
    captchaErrorText: 'Подтвердите, что вы не робот',
  });

  const sendReceivedCodeMethod = async (useV2Captcha = false, captchaV2) => {
    params.state = 'sendCode';
    const captcha = useV2Captcha === true ? captchaV2 : props.captchaOptions;
    params.isSendingCode = true;
    params.errorSendReceivedCode = '';
    try {
      if (props.isUseNewEndPoint) {
        await sendReceivedCodeNew({
          confirmCode: params.value,
          ...captcha,
        });
        params.state = 'sendPasswordToPhone';
      } else {
        await userSendReceivedCode({
          phone: props.phone,
          confirmCode: params.value,
        });
      }
      emit('verified');
    } catch (e) {
      if (!e.message?.includes(ERROR_CODE_VERIFY_RECAPTCHA_STRING)) {
        params.errorSendReceivedCode = e.message;
      }
      emit('error', e);
    } finally {
      params.isSendingCode = false;
    }
  };

  const handlerEndCountdown = () => {
    params.isCounting = false;
    params.timeLeft = -1;
  };

  const getTimeLeft = () => {
    const payload = {
      phone: props.phone,
      ...props.captchaOptions,
    };
    getPhoneInfo(payload)
      .then((dateExpired) => {
        if (dateExpired) {
          params.timeLeft = getDifferenceBetweenDateTypes(new Date(dateExpired), new Date(), 'milliseconds');
          params.isCounting = !!params.timeLeft;
        }
      });
  };

  const sendCode = async (useV2Captcha = false, captchaV2) => {
    params.showForm = false;
    params.isFetchingCode = true;
    params.state = 'confirmRecovery';
    params.errorSendReceivedCode = '';
    try {
      if (props.isUseNewEndPoint) {
        const captcha = useV2Captcha === true ? captchaV2 : props.captchaOptions;
        const payload = {
          phone: props.phone,
          ...captcha,
        };
        await sendSmsConfirmNew(payload)
          .then(() => {
            params.showCaptchaError = false;
            getTimeLeft();
          })
          .catch((error) => {
            if (error?.code === '791e4e47-8bcd-41d1-828f-f0e43796bb19') {
              params.showCaptchaError = false;
              params.errorSendReceivedCode = error.message;
              getTimeLeft();
            } else if (error?.code === ERROR_CODE_TOO_MANY_TRIES_VERIFY_PHONE) {
              params.errorSendReceivedCode = ERROR_CHECK_USER_PROBLEM.tryLater;
              params.hideResendBtn = true;
            } else if (error?.code === ERROR_PHONE_INCORRECT) {
              emit('incorrectPhone', error.message);
            } else if ((error.message && error.message.includes(ERROR_CODE_VERIFY_RECAPTCHA_STRING))
              || (error.code && error.code === ERROR_CODE_VERIFY_RECAPTCHA)) {
              emit('error', error);
              params.showCaptchaError = true;
            } else {
              params.errorSendReceivedCode = error.message;
              params.hideResendBtn = false;
              nextTick(() => {
                handlerEndCountdown();
              });
            }
          })
          .finally(() => {
            params.showForm = true;
            emit('updateCaptchaV3', 'confirmRecovery');
          });
      } else {
        params.timeLeft = await userSendConfirmCode(props.phone);
      }
      params.isCounting = !!params.timeLeft;
    } finally {
      params.isFetchingCode = false;
    }
  };

  const isDisabledInput = computed({
    get: () => params.isSendingCode || params.isFetchingCode || !params.value,
    set: () => {},
  });

  return {
    ...toRefs(params),
    countdown,
    sendReceivedCodeMethod,
    sendCode,
    handlerEndCountdown,
    getTimeLeft,
    isDisabledInput,
  };
};

export default useSmsConfirm;
